import { render, staticRenderFns } from "./IncentivesSection.vue?vue&type=template&id=794e77a3&scoped=true"
import script from "./IncentivesSection.vue?vue&type=script&lang=js"
export * from "./IncentivesSection.vue?vue&type=script&lang=js"
import style0 from "./IncentivesSection.vue?vue&type=style&index=0&id=794e77a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e77a3",
  null
  
)

export default component.exports